import { ApplicationRoutes } from '../../app-routes-names'

export const AdminRoutes = {
  shopTires: 'weekly-location-tiers',
  monthlyTargets: 'monthly-targets',
  monthlyTargetsDetail: 'monthly-targets/:locationId/:year',
  yearlyTargets: 'yearly-targets',
  yearlyTargetsDetail: 'yearly-targets/:locationId/:year',
  userList: 'user-list',
  userDetails: 'user-details/:userId',
  addUser: 'add-user',
  setMargins: 'set-margins',
  efficiencyTargets: 'efficiency-targets',
  inspectionWindows: 'inspection-windows',
  surveyList: 'survey-list',
  locationsList: 'locations-list',
  locationDetails: 'location-details/:locationId',
  salariesSummary: 'salaries-summary',
  salariesDetail: 'salaries-detail',
  viewTargets: 'view-targets',
  queueMessages: 'queue-messages',
  announcementsList: 'announcements-list',
  statusProposals: 'status-proposals',
  callTags: 'call-tags'
}

const { admin } = ApplicationRoutes

export const AdminPaths = {
  shopTires: `/${admin}/${AdminRoutes.shopTires}`,
  monthlyTargets: `/${admin}/${AdminRoutes.monthlyTargets}`,
  monthlyTargetsDetail: (locationId: string, year: number) =>
    `/${admin}/${AdminRoutes.monthlyTargetsDetail.replace(':locationId', locationId).replace(':year', year.toString())}`,
  yearlyTargets: `/${admin}/${AdminRoutes.yearlyTargets}`,
  yearlyTargetsDetail: (locationId: string, year: number) =>
    `/${admin}/${AdminRoutes.yearlyTargetsDetail.replace(':locationId', locationId).replace(':year', year.toString())}`,
  userList: `/${admin}/${AdminRoutes.userList}`,
  userDetails: (userId: string) => `/${admin}/${AdminRoutes.userDetails.replace(':userId', userId)}`,
  addUser: `/${admin}/${AdminRoutes.addUser}`,
  setMargins: `/${admin}/${AdminRoutes.setMargins}`,
  efficiencyTargets: `/${admin}/${AdminRoutes.efficiencyTargets}`,
  inspectionWindows: `/${admin}/${AdminRoutes.inspectionWindows}`,
  surveyList: `/${admin}/${AdminRoutes.surveyList}`,
  locationsList: `/${admin}/${AdminRoutes.locationsList}`,
  locationDetails: (locationId: string) =>
    `/${admin}/${AdminRoutes.locationDetails.replace(':locationId', locationId)}`,
  salariesSummary: `/${admin}/${AdminRoutes.salariesSummary}`,
  salariesDetail: `/${admin}/${AdminRoutes.salariesDetail}`,
  viewTargets: `/${admin}/${AdminRoutes.viewTargets}`,
  queueMessages: `/${admin}/${AdminRoutes.queueMessages}`,
  announcementsList: `/${admin}/${AdminRoutes.announcementsList}`,
  statusProposals: `/${admin}/${AdminRoutes.statusProposals}`,
  callTags: `/${admin}/${AdminRoutes.callTags}`
}
